import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ReferralLanding() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const c = (code || "").toUpperCase();
    if (c) {
      localStorage.setItem("hm_ref", c);
      api.post("/referral/visit", { code: c, source: "link", path: `/r/${c}` }).catch(() => {});
      toast.success("Welcome! A friend sent you — let's plan your move to Mexico.");
    }
    navigate("/", { replace: true });
  }, [code, navigate]);

  return (
    <div className="min-h-[50vh] flex items-center justify-center text-charcoal-500" data-testid="referral-landing">
      Taking you to Hola Movers…
    </div>
  );
}
